import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { TranslatePlural } from '@change-corgi/core-react/i18n';

import { usePetitionSignatureCount } from '../../../hooks/petitionStats';

type Props = {
	textAlign: 'left' | 'center' | 'right';
};

export const SignatureStatsVictoryContainer: React.FC<Props> = (
    {
        textAlign
    }
) => {
	const { signatureCount } = usePetitionSignatureCount();
	const justify = {
		left: 'justify-left text-left',
		center: 'justify-center text-center',
		right: 'justify-right text-right',
	};

	return (
		<Text size="small" variant="body" className={justify[textAlign]}>
			<TranslatePlural
				value="fe.pages.petition_show.num_supporters_victory"
				replacements={{
					num_sigs: signatureCount.displayedLocalized,
				}}
				count={signatureCount.displayed}
			/>
		</Text>
	);
};
